/**
 * Формат телефона зависит от домена панели: на `kz-1.*` регистрируются
 * казахстанские номера (+7), на остальных — узбекистанские (+998).
 * Отсюда берутся маска ввода, плейсхолдер и правило валидации.
 */
export interface IPhoneFormat {
  /** Маска для react-imask */
  mask: string;
  /** Ключ перевода для плейсхолдера */
  placeholderKey: string;
  /** Проверка значения без маски: код страны + номер */
  pattern: RegExp;
}

/** Узбекистан: 998 90 123 4567 */
const UZ_PHONE: IPhoneFormat = {
  mask: '+000 00 000 0000',
  placeholderKey: 'self_registration.phone_placeholder',
  pattern: /^998\d{9}$/,
};

/** Казахстан: 7 701 234 56 78 */
const KZ_PHONE: IPhoneFormat = {
  mask: '+0 000 000 00 00',
  placeholderKey: 'self_registration.phone_placeholder_kz',
  pattern: /^7\d{10}$/,
};

export const isKzHost = () => window.location.host.includes('kz-1');

export const getPhoneFormat = (): IPhoneFormat => (isKzHost() ? KZ_PHONE : UZ_PHONE);
